import React from "react";
import style from "../css/eventLiveCounter.css";

export default function eventLiveCounter(timer) {
    return (
        <div className={style.cont}>
            <div className={style.spinner}></div>
            <div className={style.number}>
                <span>{timer}</span>
            </div>
        </div>
    );
}


export function eventLiveTextBasedCounter(timer) {
    let blinkingStyle = () => {
        let timeLeft = Math.floor(timer);
        if (timeLeft <= 15) {
            return style.spinRed;
        } else if (timeLeft <= 30) {
            return style.spinYellow;
        } else if (timeLeft > 30) {
            return style.spinGreen;
        }
    };
    
    return (
        <div className={style.counterFrame}>
            <div className={`${style.spinner} ${blinkingStyle()}`}></div>
            <div className={`${style.number} ${style.numberTextBased}`}>
                <span>{timer}</span>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/eventLiveCounter.js